import autobind from 'core-decorators/lib/autobind';

import { notForPreview } from 'widget/utils/not-for-preview';

import ResizedImage from 'shared/components/resized-image/resized-image';
import SubscribeShownBIOverlay from 'widget/components/player-overlay/bi/_subscribe-shown-bi-overlay';
import Button from 'widget/components/button/button';
import Icon from 'shared/components/icon/icon';


export default class OverlayMemberOnlyBase extends SubscribeShownBIOverlay {

  static displayName = 'OverlayMemberOnlyBase';

  static propTypes = {
    width: React.PropTypes.number,
    height: React.PropTypes.number,
  };

  @autobind
  @notForPreview
  callPlayCallback() {
    const { videoItem: { id }, onPlayClick } = this.props;
    onPlayClick(id);
  }

  get publisher() {
    if (!this.props.canShowMainItemPublisher) {
      return null;
    }

    const publisherText = this.publisherText;

    if (!publisherText) {
      return null;
    }

    return (
      <div styleName="publisher">
        <span styleName="publisher-text">
          {publisherText}
        </span>
      </div>
    );
  }

  get buttonStyleName() {
    return 'button';
  }

  get playButton() {
    const playButtonText = this.playButtonText;

    return (
      <Button styleName={this.buttonStyleName}
              onClick={this.callPlayCallback}>
        <Icon styleName="play-icon"
              name="arrow-right-filled" />
        <span>
          { playButtonText }
        </span>
      </Button>
    );
  }

  get subscribeButton() {
    const subscribeButtonText = this.subscribeButtonText;

    if (!subscribeButtonText) {
      return null;
    }

    return (
      <Button styleName={this.buttonStyleName}
              className="qa-widget-overlay-subscribe-button"
              onClick={this.openSubscription}>
        {subscribeButtonText}
      </Button>
    );
  }

  get buttons() {
    return (
      <div styleName="buttons">
        {this.playButton}
        {this.subscribeButton}
      </div>
    );
  }

  get coverUrl() {
    const { videoItem, channelData } = this.props;

    let coverUrl = videoItem.customCoverUrl || videoItem.coverUrl;

    if (this.isChannelCoverView) {
      coverUrl = channelData.customCoverUrl || channelData.coverUrl || coverUrl;
    }

    return coverUrl;
  }

  render() {
    const { className, width, height } = this.props;
    const styles = this.getOpacityStyles();

    return (
      <div styleName="wrapper">
        <ResizedImage src={this.coverUrl}
                      width={width}
                      height={height}>
          <div style={styles}
               styleName="overlay"
               className={className}>
            {this.title}
            {this.publisher}
            {this.buttons}
          </div>
        </ResizedImage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/_base-member-only-overlay.js